import { extractTags } from "../propertyExtraction";
import {
  LANE_TYPES,
  laneDirectionArrowSpecs,
  buildArrowStyles,
} from "../util/laneDirectionArrows";

// Shows the driving direction (digitized heading combined with lane_direction) next
// to the plain geometry-directionality arrow defaultHoverStyles already draws at the
// cursor's nearest point on the line — so hovering an LM lane reveals both which way
// the geometry was digitized and which way traffic actually travels on it.
export function drivingDirectionHoverStyles(feature, resolution) {
  const tags = extractTags(feature);
  if (!LANE_TYPES.includes(tags.hdMap)) {
    return [];
  }
  const arrowSpecs = laneDirectionArrowSpecs(tags.laneDirection);
  if (!arrowSpecs.length) {
    return [];
  }

  const coordinates = feature.getGeometry().getCoordinates();
  const start = coordinates[coordinates.length - 2];
  const end = coordinates[coordinates.length - 1];
  const rotation = Math.atan2(end[1] - start[1], end[0] - start[0]);

  const styles = [];
  for (const { headingOffset } of arrowSpecs) {
    styles.push(
      ...buildArrowStyles(end, rotation, headingOffset, "black", resolution),
    );
  }
  return styles;
}
